/**
 * Login reducer
 */

import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_ERROR, LOGIN_VERIFY } from './constants';

export const initialState = {
  status: undefined,
  verifying: false,
  statusDetails: {},
};

function loginReducer(state = initialState, action) {
  console.log(action.type,action);
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        status: 'loading',
        statusDetails: {},
        username: action.values.username,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        status: 'success',
        // statusDetails: {
        //   message: 'Login successful.',
        // },
        user: action.response,
        verifying: false,
      };
    case LOGIN_VERIFY:
      return {
        ...state,
        verifying: true,
        passThroughToken: action.response,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        status: 'error',
        statusDetails: action.error,
      };
    default:
      return state;
  }
}

export default loginReducer;
